import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/stores/auth';
import { LoadingScreen } from '@/components/LoadingScreen';

interface Props {
  children: React.ReactNode;
}

/** Firebase Auth 상태를 기다린 뒤 비로그인 사용자를 /login 으로 리다이렉트 */
export function RequireAuth({ children }: Props) {
  const status = useAuthStore((s) => s.status);
  const location = useLocation();

  useEffect(() => {
    // 로그인 후 돌아올 위치를 보존
  }, [location.pathname]);

  if (status === 'loading') return <LoadingScreen />;

  if (status === 'signed-out') {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }

  return <>{children}</>;
}
